<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>
        {{ `${supplier.company_name}` }} -
        {{ $t("COMMON.LOGS") }}
      </h3>
    </div>
    <log-list-table :filterSubject="supplier" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "supplier-view-logs",

  components: { LogListTable },

  props: ["supplier"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
